import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import { isAdmin, isModerator } from "../admin/utils/roles";
import HrnbNavbar from "./controls/HrnbNavbar";
import HrnbHamburgerNav from "./controls/HrnbHamburgerNav";
import HrnbButton from "./controls/HrnbButton";
import HrnbImage from "./controls/HrnbImage";
import AuthPopup from "./auth/AuthPopup";
import NotificationBell from "./notifications/NotificationBell";
import HrnbNavbarDropdown from "./controls/HrnbNavbarDropdown";
import logo from "../logo.png"; // путь к логотипу
import {BattlesIcon, DuelIcon, TrophyIcon, ParticipantsIcon, RulesIcon, ForumIcon, ContactsIcon, MessagesIcon, CalendarIcon, RatingIcon, AdminIcon, ModerateIcon, MusicIcon} from './../icons'
import '../css/components/Menu.css'

function useIsMobile(breakpoint = 920) {
    const isClient = typeof window !== "undefined";
    const [isMobile, setIsMobile] = useState(() =>
        isClient ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches : false
    );

    useEffect(() => {
        if (!isClient) return;
        const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handler = (e) => setIsMobile(e.matches);
        // инициализация
        setIsMobile(mq.matches);

        if (mq.addEventListener) mq.addEventListener("change", handler);
        else mq.addListener(handler);

        return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", handler);
            else mq.removeListener(handler);
        };
    }, [breakpoint, isClient]);

    return isMobile;
}

const Menu = () => {
    const isMobile = useIsMobile(768)
    const [isAuthPopupOpen, setIsAuthPopupOpen] = useState(false);
    const { currentUser, signOut } = useContext(UserContext);
    // currentUser из контекста

    const handleLogout = async () => {
        await signOut();
        window.location.reload();
    };

    const handleOpenAuthPopup = () => setIsAuthPopupOpen(true);
    const handleCloseAuthPopup = () => setIsAuthPopupOpen(false);

    const links = [
        { to: "/battles", label: "Баттлы", icon: <BattlesIcon /> },
        {
            type: "dropdown",
            label: "Дуэли",
            icon: <DuelIcon />,
            items: [
                { to: "/duels", label: "Все дуэли", icon: <DuelIcon /> },
                { to: "/tournaments", label: "Турниры", icon: <TrophyIcon /> },
                { to: "/quick-duels", label: "Быстрые дуэли", icon: <RatingIcon /> }
            ]
        },
        { to: "/tournaments/annual", label: "Ежегодные турниры", icon: <TrophyIcon /> },
        { to: "/profiles", label: "Пользователи", icon: <ParticipantsIcon /> },
        { to: "/events", label: "События", icon: <CalendarIcon /> },
        { to: "/audio", label: "Аудио", icon: <MusicIcon /> },
        { to: "/chats", label: "Чаты", icon: <MessagesIcon /> },
        { to: "/rules", label: "Правила", icon: <RulesIcon /> },
        { to: "/forum", label: "Форум", icon: <ForumIcon /> },
    ];

    // Админские ссылки (добавляются в меню пользователя при наличии прав)
    const adminMenuItems = [];
    if (isAdmin(currentUser)) {
        adminMenuItems.push({ to: "/admin/dashboard", label: "Администрирование", icon: <AdminIcon /> });
    } else if (isModerator(currentUser)) {
        adminMenuItems.push({ to: "/admin/forum/posts", label: "Модерирование", icon: <ModerateIcon /> });
    }

    // Разделяем обычные ссылки и dropdown
    const regularLinks = links.filter(link => !link.type || link.type !== "dropdown");
    const dropdownLinks = links.filter(link => link.type === "dropdown");

    // isMobile из хука

    const logoNode = (
        <HrnbButton variant="ghost" style={{ padding: 0 }} icon={<HrnbImage src={logo} style={{ height: 40, width: "auto" }} />}>
        </HrnbButton>
    );

    return (
        <div>
            {isMobile ? (
                <HrnbHamburgerNav links={[...regularLinks, ...dropdownLinks]} logo={logoNode} user={currentUser} onLogout={handleLogout} onLogin={handleOpenAuthPopup} extra={<NotificationBell />} userMenuExtraItems={adminMenuItems} />
            ) : (
                <HrnbNavbar
                    links={regularLinks}
                    dropdowns={dropdownLinks}
                    logo={logoNode}
                    user={currentUser}
                    onLogout={handleLogout}
                    onLogin={handleOpenAuthPopup}
                    extra={<NotificationBell />}
                    userMenuExtraItems={adminMenuItems}
                />
            )}

            <AuthPopup isOpen={isAuthPopupOpen} onClose={handleCloseAuthPopup} />
        </div>
    );
};

export default Menu;
